module.exports = "https://web-assets.ifttt.com/packs/media/icons/checkmark-0cb3cc6b.svg";